// Generated by CoffeeScript 1.9.3
(function() {
  rjm.model.CohortDescriptor = Backbone.RelationalModel.extend({
    defaults: function() {
      return {
        cohortField: null,
        count: 8,
        minimumIntervals: 4,
        type: rjm.app.enums.cohortDescriptorType.MOVING,
        timeInterval: "MONTH",
        useRemoteMemberCount: false,
        includeCurrentPeriod: false,
        intervalsPerPoint: 1
      };
    },
    initialize: function(options) {
      var ref;
      _.bindAll(this, "defaults", "bindEnums", "unbindEnumsFromAttributes", "toJSON", "adjustStartTimes", "dateToString", "_dateAndIntervalToString", "cleanMoment");
      if ((ref = this.get("cohortField")) != null) {
        ref.fetchMinTime();
      }
      this.bind("change:cohortField", (function(_this) {
        return function(cohortDescriptor, options) {
          _this.set({
            useRemoteMemberCount: cohortDescriptor.get("cohortField").get("useRemoteMemberCount")
          });
          return _this.get("cohortField").fetchMinTime();
        };
      })(this));
      return this.bindEnums();
    },
    relations: [
      {
        type: Backbone.HasOne,
        key: "cohortField",
        relatedModel: "rjm.model.CohortField",
        includeInJSON: true
      }
    ],
    bindEnums: function() {
      if (!_(this.get("type")).isObject()) {
        this.set({
          type: rjm.app.enums.cohortDescriptorType[this.get("type")]
        });
      }
    },
    unbindEnumsFromAttributes: function(attributes) {
      attributes.type = attributes.type.serializedValue;
      return attributes;
    },
    toJSON: function() {
      var r;
      r = Backbone.RelationalModel.prototype.toJSON.call(this);
      r = this.unbindEnumsFromAttributes(r);
      return r;
    },
    adjustStartTimes: function(cohortList) {
      var adjustedTimesList, adjustedTimestamp;
      if (!_(cohortList).isArray()) {
        return;
      }
      switch (this.get("type")) {
        case rjm.app.enums.cohortDescriptorType.ALL:
          adjustedTimestamp = this.cleanMoment(moment(this.get("startTime"))).valueOf() / 1000;
          if (adjustedTimestamp < _(cohortList).first().timestamp) {
            return this.set({
              startTime: _(cohortList).first().date
            });
          } else {
            return this.set({
              startTime: moment.unix(adjustedTimestamp).format("YYYY-MM-DD 00:00:00")
            });
          }
          break;
        case rjm.app.enums.cohortDescriptorType.EXPLICIT:
          adjustedTimesList = [];
          _(this.get("startTimes")).each((function(_this) {
            return function(datetime) {
              adjustedTimestamp = _this.cleanMoment(moment(datetime)).valueOf() / 1000;
              if (adjustedTimestamp >= _(cohortList).first().timestamp && adjustedTimesList.length === 0 || adjustedTimestamp > _this.cleanMoment(moment(_(adjustedTimesList).last())).valueOf() / 1000) {
                return adjustedTimesList.push(moment.unix(adjustedTimestamp).format("YYYY-MM-DD 00:00:00"));
              }
            };
          })(this));
          return this.set({
            startTimes: adjustedTimesList
          });
      }
    },
    dateToString: function(date) {
      return this._dateAndIntervalToString(date, this.get('timeInterval'));
    },
    _dateAndIntervalToString: function(date, interval) {
      switch (interval) {
        case rjm.app.enums.timeInterval.DAY.serializedValue:
          return date.format("MMM DD, YYYY");
        case rjm.app.enums.timeInterval.WEEK.serializedValue:
          return date.format("[Week of ]MMM DD, YYYY");
        case rjm.app.enums.timeInterval.MONTH.serializedValue:
          return date.format("MMMM YYYY");
        case rjm.app.enums.timeInterval.QUARTER.serializedValue:
          return date.format("[Q]Q YYYY");
        case rjm.app.enums.timeInterval.YEAR.serializedValue:
          return date.format("YYYY");
      }
    },
    cleanMoment: function(momentInstance) {
      var ref, ref1, weekStartDayOffset;
      switch (this.get('timeInterval')) {
        case rjm.app.enums.timeInterval.DAY.serializedValue:
          return momentInstance.startOf("day");
        case rjm.app.enums.timeInterval.WEEK.serializedValue:
          weekStartDayOffset = +((ref = this.get("cohortField")) != null ? ref.get("weekStartDay") : void 0) === 7 ? 0 : +((ref1 = this.get("cohortField")) != null ? ref1.get("weekStartDay") : void 0);
          return momentInstance.startOf("week").add(weekStartDayOffset, "days");
        case rjm.app.enums.timeInterval.MONTH.serializedValue:
          return momentInstance.startOf("month");
        case rjm.app.enums.timeInterval.QUARTER.serializedValue:
          momentInstance.month(parseInt(momentInstance.month() / 3) * 3);
          return momentInstance.startOf("month");
        case rjm.app.enums.timeInterval.YEAR.serializedValue:
          return momentInstance.startOf("year");
      }
    }
  });

}).call(this);
